t = require('views/internal/teacup-with-helpers')('tips')

module.exports = t.renderable (data) ->
  { id, imgUrl1x, imgUrl2x, bgcolor, url } = data

  t.a { class: 'tip js-tip', href: url, 'data-tipid': id, target: '_blank' }, ->
    t.div { class: 'tip-image', style: "background-color: #{ bgcolor };" }, ->
      t.img
        class: 'tip-image-img'
        src: imgUrl1x
        srcset: "#{ imgUrl1x } 1x, #{ imgUrl2x } 2x"
    t.h3 '.tip-text', t.l(id)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/tip.coffee